var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divFrameWork"},[_vm._t("default"),_c('div',{staticClass:"divContent"},[_c('p',[_vm._v(_vm._s(_vm.navTitle))]),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
        src: _vm.img,
        loading: require('./../../../../../assets/wheelplanting.jpg'),
      }),expression:"{\n        src: img,\n        loading: require('./../../../../../assets/wheelplanting.jpg'),\n      }"}]}),(_vm.description.length>0)?_c('ul',_vm._l((_vm.description),function(item){return _c('li',{key:item},[_c('em'),_c('span',[_vm._v(_vm._s(item))])])}),0):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }